/**
 * @description Component-PortfolioLiquidityTable
 */
import './index.less';

import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useWrappedRangeListByUser } from '@/features/account/rangeHook';
import { useIsFetchedPortfolioList } from '@/features/portfolio/hook';
import { useChainId, useUserAddr } from '@/hooks/web3/useChain';
import EarnLiquidities from '@/pages/earn/EarnLiquidities';
interface IPropTypes {
  className?: string;
}
const PortfolioLiquidityTable: FC<IPropTypes> = function ({}) {
  const { t } = useTranslation();
  const chainId = useChainId();
  const userAddr = useUserAddr();
  const ranges = useWrappedRangeListByUser(chainId, userAddr, false);
  const isFetchedPortfolio = useIsFetchedPortfolioList(chainId, userAddr);

  if (isFetchedPortfolio && !ranges?.length) {
    return null;
  }
  return (
    <>
      <div className="syn-portfolio-liquidity-table">
        <div className="title">{t('common.liquidity')}</div>
        <EarnLiquidities isTradePage={false} />
      </div>
    </>
  );
};

export default PortfolioLiquidityTable;
